import Vue from 'vue'
import Router from 'vue-router'
const Index = r => require.ensure([], () => r(require('../pages/index.vue'))) // 首页
const GoodsImport = r => require.ensure([], () => r(require('../pages/goodsImport.vue'))) // 商品导入
const Goods = r => require.ensure([], () => r(require('../pages/goods.vue'))) // 商品管理
const ZTOrder = r => require.ensure([], () => r(require('../pages/ztOrder.vue'))) // 中通下单
const ZTOrderImport = r => require.ensure([], () => r(require('../pages/ZTOrderImport.vue'))) // 中通导入
const Order = r => require.ensure([], () => r(require('../pages/order.vue'))) // 订单管理
const Batch = r => require.ensure([], () => r(require('../pages/batch.vue'))) // 批次管理
const Cargo = r => require.ensure([], () => r(require('../pages/cargo.vue'))) // 包裹管理
const TrackPush = r => require.ensure([], () => r(require('../pages/trackPush.vue'))) // 轨迹推送
const Manager = r => require.ensure([], () => r(require('../pages/manager.vue'))) // 代理管理
const Sender = r => require.ensure([], () => r(require('../pages/sender.vue'))) // 地址管理
const LogisticsBalance = r => require.ensure([], () => r(require('../pages/logisticsBalance.vue'))) // 地址管理
const My = r => require.ensure([], () => r(require('../pages/my.vue'))) // 个人中心

const STOrder = r => require.ensure([], () => r(require('../pages/stOrder.vue'))) // 申通下单
const STOrderImport = r => require.ensure([], () => r(require('../pages/stOrderImport.vue'))) // 申通导入
const Home = r => require.ensure([], () => r(require('../pages/home.vue'))) //主页面
const Login = r => require.ensure([], () => r(require('../pages/login.vue'))) //登录页面
const Qrcode = r => require.ensure([], () => r(require('../pages/qrcode.vue'))) //扫码制单
const YIBNNeworder = r => require.ensure([], () => r(require('../pages/yiban/yibanneworder.vue'))) //一版制单
const YIBNOrderderive = r => require.ensure([], () => r(require('../pages/yiban/yibanorderderive.vue'))) //一般贸易订单导入
const Yibanstdr = r => require.ensure([], () => r(require('../pages/yiban/yibanstdr.vue'))) //申通-订单/商品导入
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)
const router = new Router({
  scrollBehavior(to, from, savePosition) {
    if (savePosition) {
      return savePosition;
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/Home',
      name: 'Home',
      component: Home,
      redirect: '/Index',
      children: [
        {
          path: '/Index',// 首页
          name: 'Index',
          component: Index
        },
        {
          path: '/GoodsImport',// 商品导入
          name: 'GoodsImport',
          component: GoodsImport
        },
        {
          path: '/Goods',// 商品管理
          name: 'Goods',
          component: Goods
        },
        {
          path: '/ZTOrder',// 中通下单
          name: 'ZTOrder',
          component: ZTOrder
        },
        {
          path: '/ZTOrderImport',// 中通导入
          name: 'ZTOrderImport',
          component: ZTOrderImport
        },
        {
          path: '/Order',// 订单管理
          name: 'Order',
          component: Order
        },
        {
          path: '/Batch',// 批次管理
          name: 'Batch',
          component: Batch
        },
        {
          path: '/Cargo',// 包裹管理
          name: 'Cargo',
          component: Cargo
        },
        {
          path: '/TrackPush',// 包裹管理
          name: 'TrackPush',
          component: TrackPush
        },
        {
          path: '/Manager',// 代理管理
          name: 'Manager',
          component: Manager
        },
        {
          path: '/Sender',// 地址管理
          name: 'Sender',
          component: Sender
        },
        {
          path: '/LogisticsBalance',// 剩余单量
          name: 'LogisticsBalance',
          component: LogisticsBalance
        },
        {
          path: '/My',// 个人中心
          name: 'My',
          component: My
        },
        {
          path: '/STOrder',// 申通下单
          name: 'STOrder',
          component: STOrder
        },
        {
          path: '/STOrderImport',// 申通导入
          name: 'STOrderImport',
          component: STOrderImport
        },
        {
          path: '/YIBNOrderderive',// 申通贸易导入
          name: 'YIBNOrderderive',
          component: YIBNOrderderive
        },
        {
          path: '/YIBNNeworder',// 申通贸易下单
          name: 'YIBNNeworder',
          component: YIBNNeworder
        },
        {
          path: '/Yibanstdr',// 申通贸易订单、商品导入
          name: 'Yibanstdr',
          component: Yibanstdr
        },
      ]
    },
  ]
})
router.beforeEach((to, from, next) => {
  if (to.path == "/") {
    if (localStorage.getItem("managerId")) {
      localStorage.removeItem("managerId");
    }
    next();
  } else if (localStorage.getItem("managerId")) {
    next();
  } else {
    Vue.prototype.$message.warning("请登录");
    next("/");
  }
})

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js